const Structure04Icon = /*#__PURE__*/ [
  ["path", { d: "M2 12C2 9.518 2.518 9 5 9H7C9.482 9 10 9.518 10 12C10 14.482 9.482 15 7 15H5C2.518 15 2 14.482 2 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 7C14 4.518 14.518 4 17 4H19C21.482 4 22 4.518 22 7C22 9.482 21.482 10 19 10H17C14.518 10 14 9.482 14 7Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 17C14 14.518 14.518 14 17 14H19C21.482 14 22 14.518 22 17C22 19.482 21.482 20 19 20H17C14.518 20 14 19.482 14 17Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 7L11 12L14 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { Structure04Icon as default };
//# sourceMappingURL=Structure04Icon.js.map
